module.exports = __webpack_public_path__ + "static/media/sydney-profile.c1a3a04c.jpg";